// import axios from 'axios'
import '../lib/jquery.min.js'
import { url } from './config.js'

// const BASE_URL = 'http://47.242.179.24:9503/'		// 测试接口地址
// const BASE_URL = 'http://admin.bitff.com/'				// 正式接口地址
const BASE_URL = url				// 正式接口地址

let langInfo
if (localStorage.getItem('lang')) {
	langInfo = JSON.parse(localStorage.getItem('lang'))
}
// langInfo = JSON.parse(localStorage.getItem('lang'))
// console.log("langInfo: ",langInfo);
// 封装请求
export const http = (url, data, params) => {
  // url：接口地址； data：请求参数； params：请求方式（get/post）

  return new Promise(function (resolve, reject) {
    $.ajax({
		url: BASE_URL + url,

		type: params,

		// dataType: params && params.dataType || 'JSON',

		dataType: 'json',
		
		headers:{
			// 'Content-Type': 'application/json',
			"language": langInfo ? langInfo.abbreviation : 'EN',
			"languageid": langInfo ? langInfo.id : 2
		},//设置请求头	
		
		data: data,

		success: function (res) {
			resolve(res)
		},

		error: function (err) {
			// alert(res.msg)
			console.log('err',err)
		}
    })
  })
}